export default class NewsCenterController {
  static getOverview(newsCenterId: string) {
    return fetch(`/api/${newsCenterId}/overview`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getNews(newsCenterId: string, newsId: string) {
    return fetch(`/api/${newsCenterId}/news/${newsId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static search(newsCenterId: string, search: string) {
    return fetch(`/api/${newsCenterId}/search?search=${search}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}